import { render, staticRenderFns } from "./students.vue?vue&type=template&id=beacf4ba&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"
import style0 from "./students.vue?vue&type=style&index=0&id=beacf4ba&prod&lang=scss"
import style1 from "./students.vue?vue&type=style&index=1&id=beacf4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beacf4ba",
  null
  
)

export default component.exports